import { render, staticRenderFns } from "./BaseMapPinIcon.vue?vue&type=template&id=d5f52f14"
import script from "./BaseMapPinIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseMapPinIcon.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports